// frontend/src/pages/FileForm.js
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import HeaderLogged from '../components/HeaderLogged';
import Footer from '../components/Footer';
import { useWizardFormId, withForm } from '../utils/wizardForm';
function FileMonth() {
  const { id } = useParams(); // id компании
  // Номер формы — из адреса этой вкладки (см. utils/wizardForm.js)
  const formId = useWizardFormId();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  // Состояния для полей формы
  const [taxPeriod, setTaxPeriod] = useState('');
  const [firstUsedMonth, setFirstUsedMonth] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Верхний бар этапов
  const steps = [
    { id: 1, label: 'Tax & Form' },
    { id: 2, label: 'Vehicles Tax' },
    { id: 3, label: 'IRS Payment Options' },
    { id: 4, label: 'Form Summary' },
    { id: 5, label: 'Payment and IRS Submission' },
    { id: 6, label: 'IRS Confirmation' },
  ];
  const currentStep = 1; // текущий этап

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`/api/companies/${id}/`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!res.ok) {
          throw new Error('Error loading company data');
        }
        const data = await res.json();
        setCompany(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [id]);

  const handle8849Month = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!firstUsedMonth) {
        setErrorMessage('Please fill in all required fields.');
        return;
      }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/form8849/${formId}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            tax_year_end_month:firstUsedMonth,
            step:2,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.log(33);
        console.error('Validation errors:', errorData);
        throw new Error('Error creating Form 8849');
      }
      const createdForm = await response.json();

      // Перенаправляем пользователя на следующий этап (Vehicles Tax)
      navigate(withForm(`/company/${id}/file-form/vehicles-tax-8849`, createdForm.id));
    } catch (error) {
      console.error(error);
      setErrorMessage('Failed to create Form 8849. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#E4F2FF]">
        <p className="text-gray-700 text-lg">Loading...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <HeaderLogged />

      {/* Верхний бар этапов */}
      <div className="bg-white shadow p-4">
        <div className="flex flex-wrap justify-center gap-2">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`px-2 py-1 sm:px-4 sm:py-2 rounded border text-center text-xs sm:text-sm ${
                step.id === currentStep
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-gray-300 text-gray-700 border-gray-300'
              }`}
            >
              {step.label}
            </div>
          ))}
        </div>
      </div>

      <main className="flex-1 bg-[#E4F2FF] p-4 flex items-center justify-center">
        <form
          className="bg-white rounded shadow p-4 sm:p-6 w-full max-w-3xl space-y-4"
          
        >
          
          <div className="space-y-2">
            <label htmlFor="firstUsedMonth" className="block font-semibold">
              Month Your Income Tax Year Ends <span className="text-red-500">*</span>
            </label>
            <select
              id="firstUsedMonth"
              required
              value={firstUsedMonth}
              onChange={(e) => setFirstUsedMonth(e.target.value)}
              className="border p-2 w-full rounded focus:outline-none focus:ring-2 focus:ring-[#0F2C5E]"
            >
              <option value="">Select</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
            </select>
            <p className="text-sm text-gray-600">
              Month Your Income Tax Year Ends refers to the last moth of your business's fiscal year. 
              This is required for IRS record-keeping and may vary based on yout account period.
            </p>
          </div>

          {errorMessage && (
            <p className="text-red-500 text-sm">{errorMessage}</p>
          )}

          <div className="flex flex-wrap gap-4 mt-4">
            <button
              type="button"
              className="bg-[#0F2C5E] text-white px-4 py-2 rounded hover:bg-blue-900 transition"
              onClick={handle8849Month}
            >
              Continue Filling
            </button>
          </div>
        </form>
      </main>

      <Footer />
    </div>
  );
}

export default FileMonth;
